import { ItemsListRowItemBase } from './list-row-item-base';
import { GetPropertyByString } from '@fi-shared/fi-shared-services/extensions.service';
import { isFunction } from '@fi-shared/utils/is-function';
import { Directive } from '@angular/core';

@Directive()
export class ItemsListRowItemBaseLink extends ItemsListRowItemBase {
    GetUiSref() {
        const Sref = this.head.Properties.ExtraProperties.Sref;
        return isFunction(this.head.Properties.ExtraProperties.Sref) ? (<any>Sref)(this.data, this.head) : Sref;
    }

    GetUiSrefParams(data?) {
        if (!this.head.Properties.ExtraProperties.SrefParams) return;
        return this.head.Properties.ExtraProperties.SrefParams(data || this.data, this.head);
    }

    GetToolTipA() {
        return GetPropertyByString(this.data, this.head.PropertyName);
    }

    GetRowItemClass() {
        return this.head.Properties.ExtraProperties.RowItemClass;
    }
}
